import { render, staticRenderFns } from "./TestimonialApp.vue?vue&type=template&id=93d137e2"
import script from "./TestimonialApp.vue?vue&type=script&lang=js"
export * from "./TestimonialApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports